import React from 'react';

import { SpotifyUrl as SpotifyUrlForm } from '@/components/Layout/components/AddCustomSong/SpotifyUrl';

import { IPropsSongModalDisplay } from '../SongModalPanel';

export const SpotifyUrl: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	updateTeamSong,
	popDisplayState,
}) => {
	return (
		<SpotifyUrlForm
			teamSong={openedSong}
			onSubmit={({ spotifyId }) => {
				updateTeamSong({ spotifyId });
				popDisplayState();
			}}
		/>
	);
};
